module.exports = __webpack_public_path__ + "img/manajemen_user.51a9c699.svg";